import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-report-for-products',
  templateUrl: './service-report-for-products.component.html',
  styleUrls: ['./service-report-for-products.component.css']
})
export class ServiceReportForProductsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
